// import React, { useState, useEffect } from 'react';
// import { Menu, X, ArrowUpRight, ChevronRight } from 'lucide-react';

// const ServicesPage = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [scrollY, setScrollY] = useState(0);
//   const [isVisible, setIsVisible] = useState({});
//   const [hoveredService, setHoveredService] = useState(null);

//   // Scroll handler for navbar background
//   useEffect(() => {
//     const handleScroll = () => setScrollY(window.scrollY);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Intersection Observer for scroll animations
//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             setIsVisible(prev => ({
//               ...prev,
//               [entry.target.id]: true
//             }));
//           }
//         });
//       },
//       { 
//         threshold: 0.1,
//         rootMargin: '0px 0px -50px 0px'
//       }
//     );

//     const elements = document.querySelectorAll('[data-animate]');
//     elements.forEach((el) => observer.observe(el));

//     return () => observer.disconnect();
//   }, []);

//   const services = [
//     {
//       id: 1,
//       title: "SPACE PLANNING",
//       description: "Proin imperdiet euismod primis auctor aenean fusce viver. Platea erat inceptos augue elit parturient dictum nec dolor venenatis penatibus accumsan ridiculus.",
//       image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&h=600&fit=crop",
//       features: ["Floor Plan Design", "Traffic Flow Optimization", "Functional Layout", "Spatial Analysis"]
//     },
//     {
//       id: 2,
//       title: "FURNITURE SELECTION",
//       description: "Etiam porttitor libero ac ipsum egestas, in agittis feugiat ut potenti pharetra dignissim gravida iaculis duis volutpat.",
//       image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&h=600&fit=crop",
//       features: ["Custom Furniture", "Material Selection", "Color Coordination", "Style Curation"]
//     },
//     {
//       id: 3,
//       title: "INTERIOR STYLING",
//       description: "Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
//       image: "https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?w=800&h=600&fit=crop",
//       features: ["Accessory Selection", "Art Curation", "Lighting Design", "Textile Coordination"]
//     },
//     {
//       id: 4,
//       title: "PROJECT MANAGEMENT",
//       description: "Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
//       image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&h=600&fit=crop",
//       features: ["Timeline Management", "Vendor Coordination", "Quality Control", "Budget Management"]
//     },
//     {
//       id: 5,
//       title: "CONSULTATION",
//       description: "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.",
//       image: "https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?w=800&h=600&fit=crop",
//       features: ["Design Analysis", "Color Consultation", "Style Guidance", "Expert Advice"]
//     },
//     {
//       id: 6,
//       title: "RENOVATION",
//       description: "Excepteur sint occaecat cupidatat non proident sunt in culpa qui officia deserunt mollit anim id est laborum.",
//       image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&h=600&fit=crop",
//       features: ["Full Renovation", "Structural Changes", "System Upgrades", "Complete Transformation"]
//     }
//   ];

//   return (
//     <div className="min-h-screen bg-[#f5f1eb] text-stone-800 overflow-x-hidden">
//       {/* Load Fonts */}
//       <link
//         href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;900&family=Inter:wght@300;400;500;600&display=swap"
//         rel="stylesheet"
//       />

//       {/* Navigation */}
//       <nav className={`fixed top-0 w-full z-50 transition-all duration-500 ${
//         scrollY > 50 ? 'bg-[#f5f1eb]/95 backdrop-blur-md shadow-lg' : 'bg-[#f5f1eb]/80 backdrop-blur-sm'
//       }`}>
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
//           <div className="flex items-center justify-between">
//             <div className="text-xl sm:text-2xl font-bold font-serif" style={{fontFamily: "'Playfair Display', serif"}}>
//               LUXE INTERIORS
//             </div>
            
//             {/* Desktop Menu */}
//             <div className="hidden md:flex items-center space-x-6 lg:space-x-8">
//               <a href="#home" className="text-stone-600 hover:text-stone-900 transition-colors font-medium text-sm lg:text-base">Home</a>
//               <a href="#services" className="text-stone-900 font-semibold text-sm lg:text-base">Services</a>
//               <a href="#portfolio" className="text-stone-600 hover:text-stone-900 transition-colors font-medium text-sm lg:text-base">Portfolio</a>
//               <a href="#about" className="text-stone-600 hover:text-stone-900 transition-colors font-medium text-sm lg:text-base">About</a>
//               <a href="#contact" className="text-stone-600 hover:text-stone-900 transition-colors font-medium text-sm lg:text-base">Contact</a>
//             </div>

//             {/* Mobile Menu Button */}
//             <button 
//               onClick={() => setIsMenuOpen(!isMenuOpen)}
//               className="md:hidden p-2"
//             >
//               {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
//             </button>
//           </div>

//           {/* Mobile Menu */}
//           <div className={`md:hidden transition-all duration-300 overflow-hidden ${
//             isMenuOpen ? 'max-h-64 opacity-100' : 'max-h-0 opacity-0'
//           }`}>
//             <div className="pt-4 pb-2 space-y-2">
//               <a href="#home" className="block py-2 text-stone-600 hover:text-stone-900">Home</a>
//               <a href="#services" className="block py-2 text-stone-900 font-semibold">Services</a>
//               <a href="#portfolio" className="block py-2 text-stone-600 hover:text-stone-900">Portfolio</a>
//               <a href="#about" className="block py-2 text-stone-600 hover:text-stone-900">About</a>
//               <a href="#contact" className="block py-2 text-stone-600 hover:text-stone-900">Contact</a>
//             </div>
//           </div>
//         </div>
//       </nav>

//       {/* Hero Section */}
//       <section className="relative min-h-screen flex items-center justify-center" style={{
//         backgroundImage: "url('https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=1600&h=1200&fit=crop')",
//         backgroundSize: 'cover',
//         backgroundPosition: 'center'
//       }}>
//         {/* Overlay */}
//         <div className="absolute inset-0 bg-stone-900/40"></div>
        
//         {/* Content */}
//         <div data-animate id="hero-content">
//           <div className={`relative z-10 text-center text-white px-4 sm:px-6 lg:px-8 transition-all duration-1000 ${isVisible['hero-content'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
//             <h1
//               className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-light mb-6 md:mb-8 tracking-wider leading-tight"
//               style={{ fontFamily: "'Playfair Display', serif" }}
//             >
//               OUR SERVICES
//             </h1>
//             <p className="text-lg sm:text-xl md:text-2xl font-light max-w-4xl mx-auto mb-8 md:mb-12 leading-relaxed">
//               Vitae habitasse potenti accumsan mauris pellentesque
//               <br />
//               venenatis varius sollicitudin.
//             </p>
//             <button className="inline-flex items-center text-white border-b border-white hover:border-stone-300 transition-all duration-300 text-sm md:text-base tracking-widest uppercase font-light pb-1">
//               CONTACT US
//             </button>
//           </div>
//         </div>
//       </section>

//       {/* Services Grid Section */}
//       <section className="py-16 md:py-24 lg:py-32 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
//             {services.map((service, index) => (
//               <div
//                 key={service.id}
//                 data-animate
//                 id={`service-${service.id}`}
//                 className={`group bg-white overflow-hidden transition-all duration-1000 ${isVisible[`service-${service.id}`] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
//                 style={{ transitionDelay: `${index * 200}ms` }}
//                 onMouseEnter={() => setHoveredService(service.id)}
//                 onMouseLeave={() => setHoveredService(null)}
//               >
//                 {/* Service Image */}
//                 <div className="relative h-[350px] md:h-[400px] overflow-hidden">
//                   <img
//                     src={service.image}
//                     alt={service.title}
//                     className={`w-full h-full object-cover transition-all duration-700 ${
//                       hoveredService === service.id ? 'scale-105' : 'scale-100'
//                     }`}
//                   />
                  
//                   {/* Arrow Icon */}
//                   <div className={`absolute top-6 right-6 w-10 h-10 md:w-12 md:h-12 bg-stone-800/70 backdrop-blur-sm rounded-full flex items-center justify-center transition-all duration-500 ${
//                     hoveredService === service.id ? 'scale-110 bg-stone-800/90' : 'scale-100'
//                   }`}>
//                     <ArrowUpRight className="w-4 h-4 md:w-5 md:h-5 text-white" />
//                   </div>
//                 </div>

//                 {/* Service Content */}
//                 <div className="p-6 md:p-8">
//                   <h3
//                     className="text-xl md:text-2xl lg:text-3xl font-light mb-4 md:mb-6 tracking-wider text-stone-900"
//                     style={{ fontFamily: "'Playfair Display', serif" }}
//                   >
//                     {service.title}
//                   </h3>
//                   <p className="text-sm md:text-base leading-relaxed text-stone-600 mb-6">
//                     {service.description}
//                   </p>
                  
//                   {/* Features List */}
//                   <div className="space-y-2">
//                     {service.features.slice(0, 3).map((feature, idx) => (
//                       <div key={idx} className="flex items-center text-xs md:text-sm text-stone-500">
//                         <div className="w-1 h-1 bg-stone-400 rounded-full mr-3"></div>
//                         {feature}
//                       </div>
//                     ))}
//                   </div>
                  
//                   {/* Learn More Link */}
//                   <div className={`mt-6 transition-all duration-300 ${
//                     hoveredService === service.id ? 'opacity-100 transform translate-y-0' : 'opacity-70 transform translate-y-1'
//                   }`}>
//                     <button className="text-stone-800 text-xs md:text-sm font-medium tracking-wider uppercase border-b border-stone-300 hover:border-stone-800 transition-all duration-300 pb-1">
//                       Learn More
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Call to Action Section */}
//       <section className="py-16 md:py-24 lg:py-32 bg-stone-800 text-white">
//         <div data-animate id="cta-section">
//           <div className={`max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 ${isVisible['cta-section'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
//             <h2
//               className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light mb-6 md:mb-8 tracking-wider"
//               style={{ fontFamily: "'Playfair Display', serif" }}
//             >
//               READY TO START YOUR PROJECT?
//             </h2>
//             <p className="text-lg md:text-xl font-light mb-8 md:mb-12 leading-relaxed opacity-90">
//               Let's discuss your vision and create something extraordinary together.
//             </p>
//             <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
//               <button className="bg-white text-stone-800 px-8 md:px-12 py-3 md:py-4 hover:bg-stone-100 transition-all duration-300 font-light text-sm md:text-base tracking-widest uppercase">
//                 GET IN TOUCH
//               </button>
//               <button className="border border-white text-white px-8 md:px-12 py-3 md:py-4 hover:bg-white hover:text-stone-800 transition-all duration-300 font-light text-sm md:text-base tracking-widest uppercase">
//                 VIEW PORTFOLIO
//               </button>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="bg-[#f5f1eb] text-stone-800 py-12 md:py-16 border-t border-stone-300">
//         <div data-animate id="footer">
//           <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 ${isVisible['footer'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
//             <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
//               <div className="md:col-span-2">
//                 <div
//                   className="text-2xl md:text-3xl font-light mb-4 md:mb-6 tracking-wider"
//                   style={{ fontFamily: "'Playfair Display', serif" }}
//                 >
//                   LUXE INTERIORS
//                 </div>
//                 <p className="text-stone-600 mb-6 md:mb-8 text-base md:text-lg leading-relaxed">
//                   Crafting extraordinary spaces since 2008. We believe in creating environments that inspire and elevate everyday living.
//                 </p>
//               </div>
              
//               <div>
//                 <h4 className="text-lg font-medium mb-4 tracking-wide" style={{ fontFamily: "'Playfair Display', serif" }}>
//                   SERVICES
//                 </h4>
//                 <ul className="space-y-2 text-stone-600">
//                   <li>Space Planning</li>
//                   <li>Furniture Selection</li>
//                   <li>Interior Styling</li>
//                   <li>Project Management</li>
//                 </ul>
//               </div>
              
//               <div>
//                 <h4 className="text-lg font-medium mb-4 tracking-wide" style={{ fontFamily: "'Playfair Display', serif" }}>
//                   CONTACT
//                 </h4>
//                 <ul className="space-y-2 text-stone-600">
//                   <li>+1 (555) 123-4567</li>
//                   <li>hello@luxeinteriors.com</li>
//                   <li>123 Design Avenue</li>
//                   <li>New York, NY 10001</li>
//                 </ul>
//               </div>
//             </div>
            
//             <div className="border-t border-stone-300 mt-8 md:mt-12 pt-6 md:pt-8 text-center">
//               <div className="text-stone-500 text-xs md:text-sm">
//                 © 2024 Luxe Interiors. All rights reserved.
//               </div>
//             </div>
//           </div>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default ServicesPage;



import React, { useState, useEffect, useRef } from 'react';
import { Menu, X, ArrowUpRight, ChevronRight } from 'lucide-react';
import living2 from './Images/Living2.webp';
import kitchen1 from './Images/KICTHENV1.webp';
import warddrobe from './Images/MasterBedroomWardrobe1.webp';
import bedroom1 from './Images/BedroomWardrobe2.webp' ;
import kitchen2 from './Images/CROCKERY (2).webp';
import bedroom2 from './Images/BEDROOM 3_ (2).webp';
import flooring from './Images/DINING.webp';
import LivingImage2 from './Images/LIVING.webp';
import wall from  './Images/WALLMURAL.webp';
import falseCeiling1 from './Images/MASTER BEDROOM _V1.webp';
import kitchen3 from './Images/Kitchen_.webp';

import bedroom3 from './Images/BEDROOM 3 (4).webp';
import LivingImage1 from './Images/Living1.webp';
import warddrobe2 from './Images/BEDROOM 2 (3).webp';
import kitchen4 from './Images/Kitchen_.webp';

// Reusable RevealImage Component
const RevealImage = ({ src, alt, className = "h-[350px] md:h-[400px]" }) => {
  const wrapperRef = useRef();
  useEffect(() => {
    const el = wrapperRef.current;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            el.classList.add("revealed");
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.3 }
    );
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, []);
  
  return (
    <div ref={wrapperRef} className={`reveal-wrapper w-full ${className} relative overflow-hidden`}>
      <img src={src} alt={alt} className="w-full h-full object-cover relative z-1" />
      <div className="reveal-mask"></div>
    </div>
  );
};

// Animated Line Component
const AnimatedLine = () => {
  const lineRef = useRef();
  useEffect(() => {
    const el = lineRef.current;
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            el.classList.add("animate-line");
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.5 }
    );
    if (el) observer.observe(el);
    return () => {
      if (el) observer.unobserve(el);
    };
  }, []);
  
  return (
    <div ref={lineRef} className="animated-line-wrapper w-full flex justify-center py-16 md:py-20">
      <div className="animated-line w-32 h-0.5 bg-stone-400"></div>
    </div>
  );
};

const ServicesPage = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const [hoveredService, setHoveredService] = useState(null);
  const [isVisible, setIsVisible] = useState({});

  // Scroll handler for navbar background
  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);


  useEffect(() => {
  window.scrollTo(0, 0);
}, []);

  // Intersection Observer for scroll animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(prev => ({
              ...prev,
              [entry.target.id]: true
            }));
          }
        });
      },
      { 
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    const elements = document.querySelectorAll('[data-animate]');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const services = [
    {
      id: 1,
      title: "MODULAR KITCHENS",
      description: "Elevate your culinary space with bespoke modular kitchens that blend sophisticated design and flawless functionality. Crafted with elegant finishes and intelligent layouts, they embody refinement and practicality in every detail",
      image: kitchen1,
      features: ["Architectural Space Planning","Luxury Workflow Design","Tailored Functional Elegance","Signature Finishes & Materials"]
    },
    {
      id: 2,
      title: "MODULAR WARDROBES",
      description: "Transform your living spaces with bespoke modular wardrobes that combine elegant aesthetics with intelligent storage solutions. Crafted with premium finishes and tailored layouts, they bring sophistication, functionality, and timeless style to every corner of your home",
      image: bedroom1,
      features: ["Customized Storage Solutions", "Elegant Space Optimization", "Tailored Interior Finishes", "Seamless Functional Design"]
    },
    {
      id: 3,
      title: "LIGHTING",
      description: "Illuminate your interiors with luxurious lighting solutions that blend ambience, elegance, and functionality. From statement fixtures to subtle accent lighting, every detail is designed to enhance mood, highlight features, and elevate the overall aesthetic",
      // image: "https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?w=800&h=600&fit=crop",
      image:bedroom2,
      features: ["Ambient Illumination", "Accent & Feature Lighting", "Luxury Fixtures & Finishes", "Smart Lighting Integration"]
    },
    {
      id: 4,
      title: "FLOORING",
      description: "Enhance your interiors with premium flooring solutions that combine durability, elegance, and style. From classic textures to contemporary designs, every surface is crafted to elevate the look and feel of your space",
      image: kitchen3,
      features: ["Luxury Hardwood & Engineered Wood", "Elegant Tiles & Stone Finishes", "Custom Patterns & Inlays", "Durable & Low-Maintenance Surfaces"]
    },
    {
      id: 5,
      title: "MODERN WIRING & POWER SOLUTIONS",
      description: "Ensure safety, efficiency, and style with comprehensive electrical systems designed for modern living. Every installation is planned to support your lifestyle seamlessly while maintaining a sleek, organized setup",
      image: LivingImage2,
      features: ["Safe & Efficient Wiring", "Smart Home Integration", "Premium Switches & Fixtures", "Energy Optimization & Management"]
    },
  {
  id: 6,
  title: "CONSTRUCTION & FINISHING",
  description: "Delivering precision and durability in every structural and finishing detail, our construction and finishing solutions ensure a solid foundation and impeccable craftsmanship for your interiors.",
  image: bedroom3,
  features: ["Structural Planning & Execution", "High-Quality Masonry & Finishes", "Custom Partitions & Layouts", "Durable & Sustainable Construction"]
},
{
  id: 7,
  title: "FALSE CEILING",
  description: "Enhance your interiors with elegant and functional false ceiling designs that blend aesthetics, acoustics, and lighting solutions. Every installation is crafted to add depth, style, and sophistication to your space.",
  image: falseCeiling1,
  features: ["Custom Design & Layouts", "Premium Materials & Finishes", "Integrated Lighting Solutions", "Acoustic & Thermal Optimization"]
},
{
  id: 8,
  title: "WALL DESIGN & PAINTING",
  description: "Transform your interiors with exquisite wall designs and premium painting solutions that combine style, texture, and color harmony. Each finish is crafted to enhance the ambiance and character of your space.",
  image: wall,
  features: ["Custom Wall Designs", "Premium Paint Finishes", "Textured & Feature Walls", "Color Consultation & Execution"]
}


  ];

  return (
    <div className="min-h-screen bg-[#f5f1eb] text-stone-800 overflow-x-hidden">
      {/* Load Fonts */}
      <link
        href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;900&family=Inter:wght@300;400;500;600&display=swap"
        rel="stylesheet"
      />

      {/* Global CSS for smooth scrolling and hidden scrollbars */}
      <style jsx global>{`
        html {
          scroll-behavior: smooth;
        }
        
        /* Hide scrollbars completely */
        ::-webkit-scrollbar {
          width: 0px;
          background: transparent;
        }
        
        body {
          scrollbar-width: none;
          -ms-overflow-style: none;
          overflow-x: hidden;
        }
        
        /* Smooth scroll momentum */
        * {
          -webkit-overflow-scrolling: touch;
        }
      `}</style>

      {/* Enhanced animations matching reference code style */}
      <style jsx>{`
        /* RevealImage Effects - Keep Simple */
        .reveal-wrapper {
          position: relative;
          overflow: hidden;
        }
        
        .reveal-wrapper .reveal-mask {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: #f5f1eb;
          transform: translateX(-100%);
          transition: transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          z-index: 2;
        }
        
        .reveal-wrapper.revealed .reveal-mask {
          transform: translateX(100%);
        }
        
        .reveal-wrapper img {
          opacity: 0;
          transform: scale(1.1);
          transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }
        
        .reveal-wrapper.revealed img {
          opacity: 1;
          transform: scale(1);
        }
        
        /* Simple Scroll Animations */
        .fade-up {
          opacity: 0;
          transform: translateY(50px);
          transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }
        
        .fade-up.visible {
          opacity: 1;
          transform: translateY(0);
        }
        
        .fade-left {
          opacity: 0;
          transform: translateX(-50px);
          transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }
        
        .fade-left.visible {
          opacity: 1;
          transform: translateX(0);
        }
        
        .fade-right {
          opacity: 0;
          transform: translateX(50px);
          transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }
        
        .fade-right.visible {
          opacity: 1;
          transform: translateX(0);
        }
        
        .zoom-in {
          opacity: 0;
          transform: scale(0.9);
          transition: all 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }
        
        .zoom-in.visible {
          opacity: 1;
          transform: scale(1);
        }
        
        /* Animated Line */
        .animated-line {
          transform: scaleX(0);
          transform-origin: left;
          transition: transform 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        }
        
        .animated-line-wrapper.animate-line .animated-line {
          transform: scaleX(1);
        }
        
        .animated-line::before {
          content: '';
          position: absolute;
          top: -1px;
          left: 0;
          width: 100%;
          height: 4px;
          background: linear-gradient(90deg, transparent 0%, #8b7355 50%, transparent 100%);
          transform: translateX(-100%);
          transition: transform 1.5s ease-out;
          border-radius: 2px;
        }
        
        .animated-line-wrapper.animate-line .animated-line::before {
          transform: translateX(100%);
        }
        
        /* Service Card Hover Effects */
        .service-card {
          transition: all 0.3s ease;
        }
        
        .service-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
        }
      `}</style>

      {/* Navigation */}
    

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Background Image */}
        <div 
          className="absolute inset-0"
          style={{
            backgroundImage: living2 ? `url(${living2})` : "url('https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=1600&h=1200&fit=crop')",
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundAttachment: 'fixed'
          }}
        ></div>
        
        {/* Overlay */}
        <div className="absolute inset-0 bg-stone-900/40"></div>
        
        {/* Content */}
        <div data-animate id="hero-content">
          <div className={`relative z-10 text-center text-white px-4 sm:px-6 lg:px-8 transition-all duration-1000 ${isVisible['hero-content'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <h1
              className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-light mb-6 md:mb-8 tracking-wider leading-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              OUR SERVICES
            </h1>
            <p className="text-lg sm:text-xl md:text-2xl font-light max-w-4xl mx-auto mb-8 md:mb-12 leading-relaxed">
           Explore our services that transform ordinary spaces into stunning
              <br />
               functional, and personalized interiors
              <br />
            </p>
            <button className="inline-flex items-center text-white border-b border-white hover:border-stone-300 transition-all duration-300 text-sm md:text-base tracking-widest uppercase font-light pb-1">
              CONTACT US
            </button>
          </div>
        </div>
      </section>


      {/* Categories Section - After Hero */}
      <section className="py-16 md:py-24 lg:py-32 bg-[#f5f1eb]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
            {/* Commercials */}
            <div
              data-animate
              id="category-1"
              className={`group transition-all duration-1000 ${isVisible['category-1'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
            >
              <div className="overflow-hidden mb-6">
                <RevealImage
                  src="https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&h=600&fit=crop"
                  alt="Commercial Interiors"
                  className="h-[400px] transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <h3
                className="text-2xl md:text-3xl font-light tracking-wider text-stone-900 text-center"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                COMMERCIALS
              </h3>
            </div>

            {/* Residential */}
            <div
              data-animate
              id="category-2"
              className={`group transition-all duration-1000 delay-200 ${isVisible['category-2'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
            >
              <div className="overflow-hidden mb-6">
                <RevealImage
                  src="https://images.unsplash.com/photo-1600210492493-0946911123ea?w=800&h=600&fit=crop"
                  alt="Residential Interiors"
                  className="h-[400px] transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <h3
                className="text-2xl md:text-3xl font-light tracking-wider text-stone-900 text-center"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                RESIDENTIAL
              </h3>
            </div>

            {/* Renovation */}
            <div
              data-animate
              id="category-3"
              className={`group transition-all duration-1000 delay-400 ${isVisible['category-3'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
            >
              <div className="overflow-hidden mb-6">
                <RevealImage
                  src="https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?w=800&h=600&fit=crop"
                  alt="Renovation Projects"
                  className="h-[400px] transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <h3
                className="text-2xl md:text-3xl font-light tracking-wider text-stone-900 text-center"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                RENOVATION
              </h3>
            </div>
          </div>
        </div>
      </section>

     

      {/* Services Grid Section */}
      <section className="py-16 md:py-24 lg:py-32 bg-[#f5f1eb]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
            {services.map((service, index) => (
              <div
                key={service.id}
                data-animate
                id={`service-${service.id}`}
                className={`group bg-white overflow-hidden service-card shadow-lg rounded-lg transition-all duration-1000 ${isVisible[`service-${service.id}`] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                style={{ transitionDelay: `${index * 200}ms` }}
                onMouseEnter={() => setHoveredService(service.id)}
                onMouseLeave={() => setHoveredService(null)}
              >
                {/* Service Image */}
                <div className="relative overflow-hidden">
                  <RevealImage
                    src={service.image}
                    alt={service.title}
                    className="h-[350px] md:h-[400px]"
                  />
                  
                  {/* Arrow Icon */}
                  <div className={`absolute top-6 right-6 w-10 h-10 md:w-12 md:h-12 bg-stone-800/70 backdrop-blur-sm rounded-full flex items-center justify-center transition-all duration-500 ${
                    hoveredService === service.id ? 'scale-110 bg-stone-800/90 rotate-45' : 'scale-100 rotate-0'
                  }`}>
                    <ArrowUpRight className="w-4 h-4 md:w-5 md:h-5 text-white" />
                  </div>

                  {/* Overlay effect on hover */}
                  <div className={`absolute inset-0 bg-gradient-to-t from-stone-900/30 to-transparent transition-opacity duration-500 ${
                    hoveredService === service.id ? 'opacity-100' : 'opacity-0'
                  }`}></div>
                </div>

                {/* Service Content */}
                <div className="p-6 md:p-8">
                  <h3
                    className="text-xl md:text-2xl lg:text-3xl font-light mb-4 md:mb-6 tracking-wider text-stone-900 transition-colors duration-300"
                    style={{ fontFamily: "'Playfair Display', serif" }}
                  >
                    {service.title}
                  </h3>
                  <p className="text-sm md:text-base leading-relaxed text-stone-600 mb-6 transition-colors duration-300">
                    {service.description}
                  </p>
                  
                  {/* Features List */}
                  <div className="space-y-2 mb-6">
                    {service.features.slice(0, 3).map((feature, idx) => (
                      <div 
                        key={idx} 
                        className={`flex items-center text-xs md:text-sm text-stone-500 transition-all duration-300 ${
                          hoveredService === service.id ? 'transform translate-x-2' : ''
                        }`}
                        style={{ transitionDelay: `${idx * 50}ms` }}
                      >
                        <div className="w-1 h-1 bg-stone-400 rounded-full mr-3"></div>
                        {feature}
                      </div>
                    ))}
                  </div>
                  
                  {/* Learn More Link */}
                  <div className={`transition-all duration-300 ${
                    hoveredService === service.id ? 'opacity-100 transform translate-y-0' : 'opacity-70 transform translate-y-1'
                  }`}>
                    <button className="text-stone-800 text-xs md:text-sm font-medium tracking-wider uppercase border-b border-stone-300 hover:border-stone-800 transition-all duration-300 pb-1">
                      Learn More
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Animated Line Separator */}
  

     
<AnimatedLine />

{/* Showcase Section */}
<section className="bg-[#f5f1eb] py-16 md:py-20 lg:py-24 overflow-hidden">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    {/* Heading */}
    <div data-animate id="showcase-heading">
      <div
        className={`text-center mb-12 md:mb-16 lg:mb-20 transition-all duration-1000 ${
          isVisible['showcase-heading']
            ? 'opacity-100 translate-y-0'
            : 'opacity-0 translate-y-10'
        }`}
      >
        <h2
          className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-light text-stone-900 mb-6 md:mb-8 tracking-[0.02em] leading-[1.1]"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          A BRIEF SHOWCASE
          <br />
          OF OUR WORK
        </h2>
        {/* <p className="text-stone-600 max-w-2xl mx-auto mb-8 md:mb-10 text-base md:text-lg leading-relaxed">
          Pharetra dapibus phasellus vehicula mauris tristique placerat,
          <br className="hidden md:block" />
          magna adipiscing magna nascetur, cursus at aenean.
        </p> */}
        <p className="text-stone-600 max-w-2xl mx-auto mb-8 md:mb-10 text-base md:text-lg leading-relaxed">
  Explore our curated portfolio where creativity meets functionality —
  <br className="hidden md:block" />
  each space is thoughtfully designed to reflect elegance, comfort, and timeless style.
</p>

        <a
          href="#portfolio"
          className="inline-block border-b-2 border-stone-900 text-stone-900 font-medium hover:opacity-70 transition-all duration-300 text-sm md:text-base tracking-[0.15em] uppercase pb-1"
        >
          SEE OUR PORTFOLIO
        </a>
      </div>
    </div>

    {/* Asymmetrical Images Layout */}
    <div data-animate id="showcase-grid">
      <div
        className={`relative transition-all duration-1000 delay-300 ${
          isVisible['showcase-grid']
            ? 'opacity-100 translate-y-0'
            : 'opacity-0 translate-y-10'
        }`}
      >
        {/* Desktop Layout */}
        <div className="hidden lg:block">
          <div className="relative h-[500px]">
            {/* Left Image */}
            <div className="absolute left-0 top-0 w-[22%] h-[380px] overflow-hidden group">
              <RevealImage
                src={warddrobe2}
                alt="Elegant Bathroom Design"
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>

            {/* Center Large Image */}
            <div className="absolute left-[26%] top-0 w-[48%] h-[500px] overflow-hidden group">
              <RevealImage
                src={LivingImage1}
                alt="Modern Living Room"
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>

            {/* Right Image */}
            <div className="absolute right-0 top-[60px] w-[22%] h-[380px] overflow-hidden group">
              <RevealImage
                src={kitchen4}
                alt="Contemporary Dining Area"
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
          </div>
        </div>

        {/* Tablet Layout */}
        <div className="hidden md:block lg:hidden">
          <div className="relative h-[450px]">
            {/* Left Image */}
            <div className="absolute left-0 top-0 w-[30%] h-[350px] overflow-hidden group">
              <RevealImage
                src={warddrobe2}
                alt="Elegant Bathroom Design"
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>

            {/* Center Large Image */}
            <div className="absolute left-[34%] top-0 w-[40%] h-[450px] overflow-hidden group">
              <RevealImage
                src={LivingImage1}
                alt="Modern Living Room"
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>

            {/* Right Image */}
            <div className="absolute right-0 top-[50px] w-[24%] h-[350px] overflow-hidden group">
              <RevealImage
                src={kitchen4}
                alt="Contemporary Dining Area"
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
          </div>
        </div>

        {/* Mobile Layout */}
        <div className="md:hidden space-y-6">
          <div className="h-[300px] overflow-hidden group">
            <RevealImage
              src={warddrobe2}
              alt="Elegant Bathroom Design"
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          </div>

          <div className="h-[400px] overflow-hidden group">
            <RevealImage
              src={LivingImage1}
              alt="Modern Living Room"
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          </div>

          <div className="h-[300px] overflow-hidden group">
            <RevealImage
              src={kitchen4}
              alt="Contemporary Dining Area"
              className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


      {/* Call to Action Section */}
      <section className="py-16 md:py-24 lg:py-32 bg-stone-800 text-white">
        <div data-animate id="cta-section">
          <div className={`max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 ${isVisible['cta-section'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <h2
              className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light mb-6 md:mb-8 tracking-wider"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              READY TO START YOUR PROJECT?
            </h2>
            <p className="text-lg md:text-xl font-light mb-8 md:mb-12 leading-relaxed opacity-90">
              Let's discuss your vision and create something extraordinary together.
            </p>
            <div data-animate id="cta-buttons">
              <div className={`flex flex-col sm:flex-row gap-6 justify-center items-center transition-all duration-1000 delay-300 ${isVisible['cta-buttons'] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
                <button className="bg-white text-stone-800 px-8 md:px-12 py-3 md:py-4 hover:bg-stone-100 transition-all duration-300 font-light text-sm md:text-base tracking-widest uppercase">
                  GET IN TOUCH
                </button>
                <button className="border border-white text-white px-8 md:px-12 py-3 md:py-4 hover:bg-white hover:text-stone-800 transition-all duration-300 font-light text-sm md:text-base tracking-widest uppercase">
                  VIEW PORTFOLIO
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      
     
    </div>
  );
};

export default ServicesPage;